import { UpdateOrderBuildStepMessage } from '@/@types/messages/UpdateOrderBuildStepMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'

export class OrderBuildStepService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public updateOrderBuildStep(orderBuildStepId: number, updateOrderBuildStepMessage: UpdateOrderBuildStepMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateOrderBuildStepMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/order-build-steps/${orderBuildStepId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}